import { Link, useLocation, useSearchParams } from 'react-router-dom';
import { CATEGORY_LABELS, PRODUCT_CATEGORIES } from '@kon/shared';
import { useCart } from '@/context/CartContext';
import { Icon } from '@/components/ui/Icon';
import { SearchBar } from './SearchBar';
import { CurrencySelector } from './CurrencySelector';
import styles from './Header.module.css';

const NAV_ITEMS = [
  { label: 'All Items', category: null },
  ...PRODUCT_CATEGORIES.map((category) => ({ label: CATEGORY_LABELS[category], category })),
];

export function Header({ onOpenCart }: { onOpenCart: () => void }) {
  const { count } = useCart();
  const [params] = useSearchParams();
  const location = useLocation();

  const activeCategory = location.pathname === '/catalog' ? params.get('category') : undefined;
  const searchValue = location.pathname === '/catalog' ? (params.get('search') ?? '') : '';

  return (
    <header className={styles.header}>
      <div className="container">
        <div className={styles.top}>
          <Link to="/" className={styles.brand} aria-label="Kon Store home">
            <span className={styles.logo} aria-hidden="true">
              🌿
            </span>
            <span className={styles.brandText}>
              <span className={styles.brandName}>
                Kon<b>Store</b>
              </span>
            </span>
          </Link>

          <span className={styles.verified}>
            <Icon name="shield" size={13} />
            Verified Seller
          </span>

          <div className={styles.searchWrap}>
            <SearchBar initialValue={searchValue} />
          </div>

          <div className={styles.actions}>
            <CurrencySelector />
            <button
              type="button"
              className={styles.cartBtn}
              onClick={onOpenCart}
              aria-label={`Open cart, ${count} item${count === 1 ? '' : 's'}`}
            >
              <Icon name="cart" size={20} />
              {count > 0 && <span className={styles.count}>{count > 99 ? '99+' : count}</span>}
            </button>
          </div>
        </div>

        <nav className={styles.nav} aria-label="Product categories">
          {NAV_ITEMS.map((item) => {
            const to = item.category ? `/catalog?category=${item.category}` : '/catalog';
            const isActive =
              location.pathname === '/catalog' &&
              (item.category ?? null) === (activeCategory ?? null);
            return (
              <Link
                key={item.label}
                to={to}
                className={`${styles.navLink} ${isActive ? styles.navActive : ''}`}
              >
                {item.label}
              </Link>
            );
          })}
        </nav>
      </div>
    </header>
  );
}
